(() => {
  function initialise(root) {
    root.querySelectorAll('[data-nta-hero-video]').forEach(holder => {
      if (holder.dataset.ntaReady === '1') return;
      holder.dataset.ntaReady = '1';
      const button = holder.querySelector('button');
      const poster = holder.querySelector('picture');
      const template = holder.querySelector('template');
      const desktop = matchMedia('(min-width: 990px)');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let video;
      function play(manual) {
        if (button.disabled) return;
        if (!video) {
          video = template.content.querySelector('video').cloneNode(true);
          video.removeAttribute('poster');
          video.playsInline = true;
          video.setAttribute('playsinline', '');
          video.controls = manual;
          video.muted = true;
          video.addEventListener('playing', () => {
            poster.hidden = true;
            button.hidden = true;
            holder.classList.add('is-playing');
            button.disabled = false;
          });
          video.addEventListener('error', restore);
          holder.appendChild(video);
        }
        video.controls = manual;
        button.disabled = true;
        const result = video.play();
        if (result && result.catch) result.catch(restore);
      }
      function restore() {
        button.disabled = false;
        button.hidden = false;
        poster.hidden = false;
        holder.classList.remove('is-playing');
      }
      button.addEventListener('click', () => play(true));
      if (desktop.matches && !motion.matches) play(false);
    });
  }
  initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
